import React from 'react';

import { IApprovals } from '@/modules/settings/approvals/types';
import { Avatar, Typography } from '@/shared/components/atoms';

import CanNotEditIcon from '~/images/shared/close-circle.svg';
import CanEditIcon from '~/images/shared/tick-circle.svg';

interface IProps {
  // id: number;
  approvers: IApprovals.IApproverItem[];
}
const ViewApproverRows = ({ approvers }: IProps) => {
  return (
    <div>
      {approvers.map((item) => (
        <div
          key={item.id}
          className='grid grid-cols-12 items-center gap-48 px-24 py-12 odd:bg-background-neutral-100 even:bg-background-neutral-99'
        >
          {/* ******************************** hierarchy ************************************ */}
          <div className='col-span-1 px-12'>
            <Typography variant='body2' weight='bold'>
              {item.hierarchy}
            </Typography>
          </div>
          {/* ******************************** approver info ********************************* */}

          <div className='col-span-6 '>
            <div className='flex items-center gap-12'>
              <div>
                <Avatar variant='single' className='bg-primary-95' />
              </div>
              <div className=''>
                <Typography variant='subtitle2' weight='bold'>
                  {item?.approverName}
                </Typography>
                <Typography variant='caption' className='text-grey-600'>
                  {item?.approverJobTitle || '-'}
                </Typography>
              </div>
            </div>
          </div>
          {/* ********************************  can edit ************************************ */}
          <div className='col-span-3 '>
            <div className='flex items-center gap-12'>
              {item?.canEdit ? (
                <CanEditIcon className='text-20' />
              ) : (
                <CanNotEditIcon className='text-20' />
              )}
            </div>
          </div>
          {/* *********************************  actions ************************************ */}
          <div className='col-span-2 '></div>
        </div>
      ))}
    </div>
  );
};
export default ViewApproverRows;
